import React from 'react'
import PropTypes from 'prop-types'
import { Image } from 'components/qstrap'
import SubmitButton from './SubmitButton'

const SubmitMessage = ({ hidden }) => (
  <div className="container" hidden={hidden}>
    <div className="img-wrap">
      <Image src="/assets/img/search/submitted-4-x.png" alt="paperplane" />
    </div>
    <div className="text-wrap">
      <div>
        <p className="title font-weight-bold">Terima Kasih telah membantu Quipper Campus!</p>
        <p>Masukan dari teman-teman sangat kami butuhkan agar Quipper Campus menjadi lebih baik lagi</p>
      </div>
    </div>
    <SubmitButton className="submit-close" onClick={() => window.location.reload()}>Tutup</SubmitButton>
    <style jsx>{`
      :global(.submit-close){
        margin: 10px auto;
        
        @media(max-width: 577px) {
          width: 100% !important;
        }
      }
      
      .container {
        display: flex;
        flex-wrap: wrap;
        text-align: center;
        justify-content: center;
      }

      .img-wrap {
        display: flex;
        justify-content: center;
        margin: 40px;

        @media(max-width: 577px) {
          margin: 40px auto;
        }
      }
      .text-wrap {
        display: flex;
        align-items: center;
        width:400px;
      }
      .title {
        color: #1e3f6b;
        font-size: 16px !important;
        margin-bottom: 16px;
      }

      p {
        font-size: 14px !important;
      }  
    `}
    </style>
  </div>
)

SubmitMessage.propTypes = {
  hidden: PropTypes.bool,
}

export default SubmitMessage
